import { USER_INPUT_FILTER_CHECKBOX_GROUP_ROLE, USER_INPUT_FILTER_CHECKBOX_ROLE, USER_INPUT_FILTER_DROPDOWN_ROLE, USER_INPUT_FILTER_RADIOGROUP_ROLE, USER_INPUT_FILTER_RANGE_SLIDER_ROLE, USER_INPUT_FILTER_SELECTION_TAGS_ROLE, USER_INPUT_FILTER_COMPONENT_TYPE, USER_INPUT_FILTER_CONDITIONS, } from '@wix/wix-data-client-common-standalone';
import { AllowedFilterOperator, FieldType } from '@wix/wix-data-schema-types';
export const USER_INPUT_FILTER_ROLES = [
    USER_INPUT_FILTER_DROPDOWN_ROLE,
    USER_INPUT_FILTER_CHECKBOX_ROLE,
    USER_INPUT_FILTER_RADIOGROUP_ROLE,
    USER_INPUT_FILTER_CHECKBOX_GROUP_ROLE,
    USER_INPUT_FILTER_SELECTION_TAGS_ROLE,
    USER_INPUT_FILTER_RANGE_SLIDER_ROLE,
];
const { EQUALS, NOT_EQUALS, INCLUDES_ALL, INCLUDES_ANY, EXCLUDES_ANY, GREATER_THAN_OR_EQUAL, LESS_THAN_OR_EQUAL, IN_BETWEEN, OUTSIDE_OF, } = USER_INPUT_FILTER_CONDITIONS;
const { SINGLE_CHOICE, MULTI_CHOICE, CHECKBOX, RANGE_SLIDER } = USER_INPUT_FILTER_COMPONENT_TYPE;
export const userInputFilterComponentTypeByRole = {
    [USER_INPUT_FILTER_DROPDOWN_ROLE]: SINGLE_CHOICE,
    [USER_INPUT_FILTER_RADIOGROUP_ROLE]: SINGLE_CHOICE,
    [USER_INPUT_FILTER_CHECKBOX_GROUP_ROLE]: MULTI_CHOICE,
    [USER_INPUT_FILTER_SELECTION_TAGS_ROLE]: MULTI_CHOICE,
    [USER_INPUT_FILTER_CHECKBOX_ROLE]: CHECKBOX,
    [USER_INPUT_FILTER_RANGE_SLIDER_ROLE]: RANGE_SLIDER,
};
const toArrayIfNeeded = (value) => Array.isArray(value) ? value : [value];
export const resolveCondition = (condition) => {
    switch (condition) {
        case EQUALS:
            return {
                getFilterQuery: (fieldName, value) => ({
                    [fieldName]: Array.isArray(value) ? { $hasSome: value } : value,
                }),
                requiredQueryOperators: [
                    AllowedFilterOperator.eq,
                    AllowedFilterOperator.hasSome,
                ],
            };
        case NOT_EQUALS:
            return {
                getFilterQuery: (fieldName, value) => ({
                    $not: [
                        {
                            [fieldName]: Array.isArray(value) ? { $hasSome: value } : value,
                        },
                    ],
                }),
                requiredQueryOperators: [
                    AllowedFilterOperator.eq,
                    AllowedFilterOperator.hasSome,
                ],
            };
        case INCLUDES_ANY:
            return {
                getFilterQuery: (fieldName, value) => ({
                    [fieldName]: { $hasSome: toArrayIfNeeded(value) },
                }),
                requiredQueryOperators: [AllowedFilterOperator.hasSome],
            };
        case EXCLUDES_ANY:
            return {
                getFilterQuery: (fieldName, value) => ({
                    $not: [
                        {
                            [fieldName]: { $hasSome: toArrayIfNeeded(value) },
                        },
                    ],
                }),
                requiredQueryOperators: [AllowedFilterOperator.hasSome],
            };
        case INCLUDES_ALL:
            return {
                getFilterQuery: (fieldName, value) => ({
                    [fieldName]: { $hasAll: toArrayIfNeeded(value) },
                }),
                requiredQueryOperators: [AllowedFilterOperator.hasAll],
            };
        case GREATER_THAN_OR_EQUAL:
            return {
                getFilterQuery: (fieldName, value) => ({
                    [fieldName]: { $gte: value },
                }),
                requiredQueryOperators: [AllowedFilterOperator.gte],
            };
        case LESS_THAN_OR_EQUAL:
            return {
                getFilterQuery: (fieldName, value) => ({
                    [fieldName]: { $lte: value },
                }),
                requiredQueryOperators: [AllowedFilterOperator.lte],
            };
        case IN_BETWEEN:
            return {
                getFilterQuery: (fieldName, value) => ({
                    [fieldName]: {
                        $gte: value[0],
                        $lte: value[1],
                    },
                }),
                requiredQueryOperators: [
                    AllowedFilterOperator.gte,
                    AllowedFilterOperator.lte,
                ],
            };
        case OUTSIDE_OF:
            return {
                getFilterQuery: (fieldName, value) => ({
                    $not: [
                        {
                            [fieldName]: {
                                $gte: value[0],
                                $lte: value[1],
                            },
                        },
                    ],
                }),
                requiredQueryOperators: [
                    AllowedFilterOperator.gte,
                    AllowedFilterOperator.lte,
                ],
            };
        default:
            return {
                getFilterQuery: (fieldName, value) => ({
                    [fieldName]: Array.isArray(value) ? { $hasSome: value } : value,
                }),
                requiredQueryOperators: [
                    AllowedFilterOperator.eq,
                    AllowedFilterOperator.hasSome,
                ],
            };
    }
};
export const userInputFilterConditionOptions = [
    {
        componentType: SINGLE_CHOICE,
        fieldType: FieldType.text,
        condition: EQUALS,
        supportsReferences: true,
        title: 'wixStudio.userInputFilter.condition.singleChoice.text.equals.title',
        description: 'wixStudio.userInputFilter.condition.singleChoice.text.equals.description',
        label: 'User_Input_Filters_Default_Label',
        placeholder: 'User_Input_Filters_Dropdown_Placeholder',
    },
    {
        componentType: SINGLE_CHOICE,
        fieldType: FieldType.text,
        condition: NOT_EQUALS,
        supportsReferences: true,
        title: 'wixStudio.userInputFilter.condition.singleChoice.text.notEquals.title',
        description: 'wixStudio.userInputFilter.condition.singleChoice.text.notEquals.description',
        label: 'User_Input_Filters_Label_ExcludeBy',
        placeholder: 'User_Input_Filters_Dropdown_Exclude_Placeholder',
    },
    {
        componentType: SINGLE_CHOICE,
        fieldType: FieldType.number,
        condition: EQUALS,
        supportsReferences: true,
        title: 'wixStudio.userInputFilter.condition.singleChoice.number.equals.title',
        description: 'wixStudio.userInputFilter.condition.singleChoice.number.equals.description',
        label: 'User_Input_Filters_Label_Field_Equals',
        placeholder: 'User_Input_Filters_Dropdown_Placeholder',
    },
    {
        componentType: SINGLE_CHOICE,
        fieldType: FieldType.number,
        condition: NOT_EQUALS,
        supportsReferences: true,
        title: 'wixStudio.userInputFilter.condition.singleChoice.number.notEquals.title',
        description: 'wixStudio.userInputFilter.condition.singleChoice.number.notEquals.description',
        label: 'User_Input_Filters_Label_Field_NotEquals',
        placeholder: 'User_Input_Filters_Dropdown_Exclude_Placeholder',
    },
    {
        componentType: SINGLE_CHOICE,
        fieldType: FieldType.number,
        condition: GREATER_THAN_OR_EQUAL,
        supportsReferences: false,
        title: 'wixStudio.userInputFilter.condition.singleChoice.number.greaterThanOrEqual.title',
        description: 'wixStudio.userInputFilter.condition.singleChoice.number.greaterThanOrEqual.description',
        label: 'User_Input_Filters_Label_Field_IsMoreThan',
        placeholder: 'User_Input_Filters_Dropdown_Placeholder',
    },
    {
        componentType: SINGLE_CHOICE,
        fieldType: FieldType.number,
        condition: LESS_THAN_OR_EQUAL,
        supportsReferences: false,
        title: 'wixStudio.userInputFilter.condition.singleChoice.number.lessThanOrEqual.title',
        description: 'wixStudio.userInputFilter.condition.singleChoice.number.lessThanOrEqual.description',
        label: 'User_Input_Filters_Label_Field_IsLessThan',
        placeholder: 'User_Input_Filters_Dropdown_Placeholder',
    },
    {
        componentType: SINGLE_CHOICE,
        fieldType: FieldType.stringArray,
        condition: INCLUDES_ANY,
        supportsReferences: true,
        title: 'wixStudio.userInputFilter.condition.singleChoice.tags.includes.title',
        description: 'wixStudio.userInputFilter.condition.singleChoice.tags.includes.description',
        label: 'User_Input_Filters_Default_Label',
        placeholder: 'User_Input_Filters_Dropdown_Placeholder',
    },
    {
        componentType: SINGLE_CHOICE,
        fieldType: FieldType.stringArray,
        condition: EXCLUDES_ANY,
        supportsReferences: true,
        title: 'wixStudio.userInputFilter.condition.singleChoice.tags.excludes.title',
        description: 'wixStudio.userInputFilter.condition.singleChoice.tags.excludes.description',
        label: 'User_Input_Filters_Label_ExcludeBy',
        placeholder: 'User_Input_Filters_Dropdown_Exclude_Placeholder',
    },
    {
        componentType: MULTI_CHOICE,
        fieldType: FieldType.text,
        condition: INCLUDES_ANY,
        supportsReferences: true,
        title: 'wixStudio.userInputFilter.condition.multiChoice.text.equals.title',
        description: 'wixStudio.userInputFilter.condition.multiChoice.text.equals.description',
        label: 'User_Input_Filters_Label_FilterItemsWith',
    },
    {
        componentType: MULTI_CHOICE,
        fieldType: FieldType.text,
        condition: EXCLUDES_ANY,
        supportsReferences: true,
        title: 'wixStudio.userInputFilter.condition.multiChoice.text.notEquals.title',
        description: 'wixStudio.userInputFilter.condition.multiChoice.text.notEquals.description',
        label: 'User_Input_Filters_Label_FilterOutItemsWith',
    },
    {
        componentType: MULTI_CHOICE,
        fieldType: FieldType.number,
        condition: INCLUDES_ANY,
        supportsReferences: true,
        title: 'wixStudio.userInputFilter.condition.multiChoice.number.equals.title',
        description: 'wixStudio.userInputFilter.condition.multiChoice.number.equals.description',
        label: 'User_Input_Filters_Label_Field_Equals',
    },
    {
        componentType: MULTI_CHOICE,
        fieldType: FieldType.number,
        condition: EXCLUDES_ANY,
        supportsReferences: true,
        title: 'wixStudio.userInputFilter.condition.multiChoice.number.notEquals.title',
        description: 'wixStudio.userInputFilter.condition.multiChoice.number.notEquals.description',
        label: 'User_Input_Filters_Label_Field_NotEquals',
    },
    {
        componentType: MULTI_CHOICE,
        fieldType: FieldType.stringArray,
        condition: INCLUDES_ANY,
        supportsReferences: true,
        title: 'wixStudio.userInputFilter.condition.multiChoice.tags.includesAny.title',
        description: 'wixStudio.userInputFilter.condition.multiChoice.tags.includesAny.description',
        label: 'User_Input_Filters_Default_Label',
    },
    {
        componentType: MULTI_CHOICE,
        fieldType: FieldType.stringArray,
        condition: EXCLUDES_ANY,
        supportsReferences: true,
        title: 'wixStudio.userInputFilter.condition.multiChoice.tags.excludesAny.title',
        description: 'wixStudio.userInputFilter.condition.multiChoice.tags.excludesAny.description',
        label: 'User_Input_Filters_Label_ExcludeBy',
    },
    {
        componentType: MULTI_CHOICE,
        fieldType: FieldType.stringArray,
        condition: INCLUDES_ALL,
        supportsReferences: true,
        title: 'wixStudio.userInputFilter.condition.multiChoice.tags.includesAll.title',
        description: 'wixStudio.userInputFilter.condition.multiChoice.tags.includesAll.description',
        label: 'User_Input_Filters_Label_IncludeAllBy',
    },
    {
        componentType: CHECKBOX,
        fieldType: FieldType.boolean,
        condition: EQUALS,
        supportsReferences: false,
        title: 'wixStudio.userInputFilter.condition.checkbox.boolean.equals.title',
        description: 'wixStudio.userInputFilter.condition.checkbox.boolean.equals.description',
        label: 'User_Input_Filters_Default_Label',
    },
    {
        componentType: CHECKBOX,
        fieldType: FieldType.boolean,
        condition: NOT_EQUALS,
        supportsReferences: false,
        title: 'wixStudio.userInputFilter.condition.checkbox.boolean.notEquals.title',
        description: 'wixStudio.userInputFilter.condition.checkbox.boolean.notEquals.description',
        label: 'User_Input_Filters_Label_ExcludeBy',
    },
    {
        componentType: RANGE_SLIDER,
        fieldType: FieldType.number,
        condition: IN_BETWEEN,
        supportsReferences: false,
        title: 'wixStudio.userInputFilter.condition.rangeSlider.number.inBetween.title',
        description: 'wixStudio.userInputFilter.condition.rangeSlider.number.inBetween.description',
        label: 'User_Input_Filters_Default_Label',
    },
    {
        componentType: RANGE_SLIDER,
        fieldType: FieldType.number,
        condition: OUTSIDE_OF,
        supportsReferences: false,
        title: 'wixStudio.userInputFilter.condition.rangeSlider.number.outsideOf.title',
        description: 'wixStudio.userInputFilter.condition.rangeSlider.number.outsideOf.description',
        label: 'User_Input_Filters_Label_FilterOutBy',
    },
];
//# sourceMappingURL=userInputFilters.js.map